'use strict';
/**
 * Service keeping reference to a scope that is currently active and offering printing functionality.
 * The controller/component/directive with printing abilitity should register with this service when active.
 * The UI should call printService.print() to start printing, while the printService will delegate this to
 * the specific scope to print since this scope should know how (e.g. a frame vs. a div).
 *
 * This service is common to all autoremind modules.
 *
 * TODO: Add print.css for styling of the print output
 * TODO: We may extend this service to offer view/save as PDF
 * TODO: We may extend this to handle Ctrl-P keyboard events to trigger printing
 *
 * TODO: Add support for creating hidden printable content: https://dzone.com/articles/building-simple-angularjs
 */
angular.module('autoremind.services')
    .factory('printService', ['$rootScope', 'logger',
    function ($rootScope, logger) {
        var service = null; // Initialize to avoid warnings in Eclipse
        service = {
            activeScope: null,
            clearModel: function () {
                service.activeScope = null;
            },
            print: function () {
                if (service.activeScope) {
                    service.activeScope.print();
                }
            }
        };
        $rootScope.$on('event:auth-loginConfirmed', function () {
            service.clearModel();
        });
        $rootScope.$on('event:auth-logout', function () {
            service.clearModel();
        });
        return service;
    }]);
//# sourceMappingURL=print-service.js.map